
















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Prefs } from '@/common/ts/_Prefs';
import { fetchFormItemCity } from '@/common/ts/_ApiConnector';
import { get } from "store";
import { watch } from "@vue/composition-api";

declare global {
  interface Window{
    dataLayer: GtmDiagnosis[];
  }
}

interface GtmDiagnosis {
  diagnosisQuestion: string;
}

interface OptionIF {
  id: number;
  diagnosisQuestionId: number;
  sentence: string;
  annotation: string;
  viewOrder: number;
}

interface QuestionIF {
  id: number;
  question: string;
  viewOrder: number;
  options: OptionIF[];
}
interface SelectedOptionIF {
  questionId: number;
  optionId: number | string;
}

interface areaListsIF {
  group: string;
  areas: {
    name: string;
    value: number | string;
  }[];
}

interface PrefsGroupIF {
  group: string;
  prefs: {
    name: string;
    value: number;
  }[];
}

interface areaValueIF { 
  id: number | string;
  name: string 
}

interface costsIF {
  id: number;
  name: string;
}


const DIAGNOSIS_ = 'diagnosis--'
const MAINAREA_QUESTION = "mainArea_question"
const SLIDE_PARTTERN_L = 'v-slideRightToLeft'
const SLIDE_PARTTERN_R = 'v-slideLeftToRight'


@Component
export default class App extends Vue {
  // private変数をコンストラクタ内で値の代入をする場合は`!`つける必要がある
  private totalQuestionNum!: number;
  private currentQuestionNum!: number;
  private remainingQuestionNum!: number;
  private diagnosisQuestions!: QuestionIF[];
  private displayedQuestion!: QuestionIF;
  private selectedStack!: SelectedOptionIF[];
  private sectionClass!: string[]
  private slidePattern!: string
  private prefsGroups!: PrefsGroupIF[];
  private areaLists!: areaListsIF[];
  private prefValue!: areaValueIF;
  private cityValue!: areaValueIF;
  private modalType!: string;
  private isModalOpen!: boolean;
  private nextButtonText!: string;
  private charges!: costsIF[];
  private monthly!: costsIF[];

  constructor() {
    super();
    this.diagnosisQuestions = JSON.parse(document.documentElement.dataset?.diagnosisQuestions || "{}")
    this.displayedQuestion = this.diagnosisQuestions[0]; // 初期値なので第一要素を取得する
    this.currentQuestionNum = 1; // 現在質問No
    this.totalQuestionNum = this.diagnosisQuestions.length;
    this.remainingQuestionNum = this.totalQuestionNum - this.currentQuestionNum + 1;
    this.selectedStack = [] // 選択肢用スタック
    this.sectionClass =  [MAINAREA_QUESTION, DIAGNOSIS_ + this.currentQuestionNum.toString()]
    this.slidePattern = SLIDE_PARTTERN_L
    this.prefsGroups = Prefs.groupedValues();
    this.areaLists = [];
    this.prefValue = { id: 0, name: "都道府県を選択してください" };
    this.cityValue = { id: 0, name: "市区町村を選択してください" };;
    this.modalType = "";
    this.isModalOpen = false;
    this.nextButtonText = "次の質問へ";
    this.charges = [];
    this.monthly = [];
  }
  onClickOption(questionId: number, optionId: number): void {
    let option: string | number;
    if (questionId === 7) {
      option = String(this.prefValue.id) + "_" + this.cityValue.id;
      this.nextButtonText = "診断結果をみる";
      this.setCost();
    } else if (questionId === 8){
      option = String($("#chargesCosts").val()) + "_" + String($("#monthlyCosts").val())
    }else {
      option = optionId;
    }  
    // クリックされた選択肢をスタックにpush
    const selectedOption: SelectedOptionIF = {
      questionId: questionId,
      optionId: option
    }
    this.selectedStack.push(selectedOption)
    
    // クリックされた選択肢に関する情報をGTM dataLayer変数にpush
    const gtmDiagnosis: GtmDiagnosis = {
      // どの質問まで進んだのかをdiagnosisQuestionの値として発火するのでcurrentQuestionNumに1足す
      diagnosisQuestion: 'diagnosisQ_' + (this.currentQuestionNum + 1).toString(),
    }
    window.dataLayer.push(gtmDiagnosis)

    // 次選択肢の取得
    const displayedViewOrder = this.displayedQuestion.viewOrder;
    const nextViewOrder = displayedViewOrder + 1;
    const nextOption: QuestionIF | undefined = this.diagnosisQuestions.find(
      op => op.viewOrder == nextViewOrder
    );

    if (nextOption) {
      // 次選択肢が存在する場合
      this.displayedQuestion = nextOption;
    } else {
      // resultに遷移する
      const resultParam: string = this.selectedStack.reduce((acc, cur, idx) => `${acc}${idx != 0 ? '&' : ''}qt${cur.questionId}=${cur.optionId}`, '?')
      location.href = `/diagnosis/result/${resultParam}`
      return
    }

    // スライドパターンの設定
    this.slidePattern = SLIDE_PARTTERN_L

    // 現在質問Noや残質問数の更新 
    this.currentQuestionNum++;
    this.remainingQuestionNum = this.getRemainNum();
    this.sectionClass =  [MAINAREA_QUESTION, DIAGNOSIS_ + this.currentQuestionNum.toString()]
  }
  
  onClickPrev(): void {

    // スタックから末尾要素を削除
    this.selectedStack.pop()

    // 表示を前選択肢に戻す
    const displayedViewOrder = this.displayedQuestion.viewOrder;
    const prevViewOrder = displayedViewOrder - 1;
    const prevOption: QuestionIF | undefined = this.diagnosisQuestions.find(
      op => op.viewOrder == prevViewOrder
    );

    if(prevOption){
      this.displayedQuestion = prevOption
    }else{
      alert('不正な動作が検出されたので、Topページに遷移します')
      location.href = './'
    }

    // スライドパターンの設定
    this.slidePattern = SLIDE_PARTTERN_R

    // 現在質問Noや残質問数の更新 
    this.currentQuestionNum--;
    this.remainingQuestionNum = this.getRemainNum();
    this.sectionClass =  [MAINAREA_QUESTION, DIAGNOSIS_ + this.currentQuestionNum.toString()]

    if (this.currentQuestionNum === 7) {
      this.nextButtonText = "次の質問へ"
    }

  }

  openModal(type:string): void {
    this.modalType = type;
    const htmlElement = document.querySelector('html');
    if (htmlElement) {
        htmlElement.style.overflow = 'hidden';
    }

    if(type === 'pref'){
      const prefs = Prefs.groupedValues();
      this.areaLists = prefs.map((group) => ({
        group: group.group, 
        areas: group.prefs.map((pref) => ({
          name: pref.name, 
          value: pref.value,
        }))
      }));
    }else if(type === 'city'){
      this.getCities();
    }
    this.isModalOpen = true
  }

  closeModal(event:Event): void {
    event.preventDefault()
    event.stopImmediatePropagation();
    $('html').css('overflow', 'auto')
    this.isModalOpen = false
  }

  onCahngePref(): void {
    this.cityValue = { id: 0, name: "市区町村を選択してください" };
    this.getCities();
  }

  async getCities(): Promise<void> {
    const prefId = this.prefValue.id;
    await fetch(`/api/facility?pref=${prefId}&groupby=city3`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        this.areaLists = data.result.map((group:any) => ({
          group: group.name, 
          areas: group.cities.map((city:any) => ({
            name: city.name, 
            value: city.jiscode
          }))
        }));
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error);
      });
  }

  async setCost(): Promise<void> {
    await fetch(`/api/charges_costs`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        this.charges = data;
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error);
      });
    await fetch(`/api/monthly_costs`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        data.shift();
        this.monthly = data;
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error);
      });
    
  }

  isDisabled(): boolean {
    if (this.currentQuestionNum === 7) {
      return !(this.prefValue.id !== 0 && this.cityValue.id !== 0);
    } 
    return false;
  }

  onClickArea(area:areaValueIF, event:Event) : void {
    if(this.modalType === 'pref'){
      this.prefValue = area;
      this.onCahngePref();
    }else if(this.modalType === 'city'){
      this.cityValue = area;
    }
    this.closeModal(event);
  }
  
  onClickCity(jiscode:string, cityName:string, event:Event): void {
    // this.cityText = cityName
    // this.jiscode = jiscode
    // this.closeModal(event)
  }

  getRemainNum(): number {
      return this.totalQuestionNum - this.currentQuestionNum + 1
  }
}
